<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="添加Banner"
      width="800px"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        :model="bannerDetail"
        ref="bannerForm"
        class="banner-form"
        :rules="rules"
        label-width="180px"
      >
        <!-- <el-form-item label="广告位置：" prop="type">
          <el-select v-model="bannerDetail.type" placeholder="请选择">
            <el-option
              v-for="item in positionTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>-->
         <div class="flex_div">
        <el-form-item label="场景：" prop="type">
          <el-select v-model="bannerDetail.type" placeholder="请选择">
            <el-option
              v-for="item in bannerTypes"
              :key="item.type"
              :label="item.message"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="bannertype">
          <el-select v-model="bannerDetail.bannerType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        </div>
        <el-form-item label="标题：" prop="title">
          <el-input v-model="bannerDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="imageUrl">
          <upload v-model="bannerDetail.imageUrl" :data="query"></upload>
        </el-form-item>
        <el-form-item label="跳转地址：" prop="linkUrl">
          <el-input v-model="bannerDetail.linkUrl"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave('bannerForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Upload from "components/upload";

export default {
  name: "CreateBanner",
  props: ["value"],
  data() {
    return {
      dialogVisible: false,
      bannerDetail: {},
      rules: {
        title: [{ required: true, message: "标题不能为空！" }],
        imageUrl: [{ required: true, message: "图片不能为空！" }],
      },
      options: [
        {
          value: "image",
          label: "图片",
        },
        {
          value: "custom",
          label: "自定义",
        },
      ],
    };
  },
  components: {
    Upload,
  },
  computed: {
    ...mapState("appFunctionalPageSetting", [
      "positionTypeList",
      "platformTypeList",
      "languageList",
      "query",
      "bannerTypes",
    ]),
    ...mapGetters("appFunctionalPageSetting", ["bannerList"]),
  },
  methods: {
    ...mapActions("appFunctionalPageSetting", ["create", "list"]),
    closeDialog() {
      this.dialogVisible = false;
      this.bannerDetail = {};
      this.$refs["bannerForm"].resetFields();
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create({ ...this.query, ...this.bannerDetail }).then(() => {
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.dialogVisible = false;
            this.$emit("refresh");
          });
        }
      });
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      }
  },
};
</script>

<style lang="less" scoped>
.banner-form {
  margin-right: 100px;
}
.flex_div {
  display: flex;
}
</style>
